import { HttpRequest, HttpResponse, HttpStatusCode } from '@angular/common/http';
import { ApiEndpointService } from 'app/core/services/api-endpoint.service';
import { makeClaimConversation } from 'app/mocks/factories/claims/makes/make-claim-conversation';
import { makeEndpointMatcher } from 'app/mocks/utils/make-endpoint-matcher';
import { IMockRegistry } from 'app/mocks/interfaces/mock-registry.interface';

export function mockClaimConversation(apiEndpointService: ApiEndpointService): IMockRegistry {
    const endpointKey = 'claims.conversations.get';
    const endpointMatcher = makeEndpointMatcher(endpointKey, apiEndpointService);

    return {
        method: 'GET',
        ...endpointMatcher,
        handler: (req: HttpRequest<unknown>, params: Record<string, string>) => {
            const claimId = Number(params.claimId);
            const topic = String(params.topic) ?? 'general';

            return new HttpResponse({
                status: HttpStatusCode.Ok,
                body: makeClaimConversation(topic, { claimId }),
            });
        },
    };
}

